import { render, staticRenderFns } from "./submitCandidate.vue?vue&type=template&id=21af3447"
import script from "./submitCandidate.vue?vue&type=script&lang=js"
export * from "./submitCandidate.vue?vue&type=script&lang=js"
import style0 from "./submitCandidate.vue?vue&type=style&index=0&id=21af3447&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports